<template>
    <div class="pricing-plan-cards-section">
        <div class="col-lg-12 pricing-card-section">
            <div class="pricing-card">
                <validation-observer ref="form" style="width: 80%;">
                    <form style="width: 100%;">

                        <h2>Stap 1: Uw gegevens</h2>
                        <div class="form-group row">
                            <label for="userEmail" class="col-sm-2 col-form-label">Uw Naam *</label>
                            <div class="col-sm-10">
                                <validation-provider rule="required" v-slot="{ errors }">
                                    <input required autocomplete="new-password" type="text" class="form-control" id="userName" v-model="family.userName" placeholder="Uw voor- en familienaam">
                                    <div class="invalid-feedback">
                                        <span>{{ errors[0] }}</span>
                                    </div>
                                </validation-provider>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="userEmail" class="col-sm-2 col-form-label">Email *</label>
                            <div class="col-sm-10">
                                <validation-provider rule="required|email" v-slot="{ errors }">
                                    <input required autocomplete="new-password" type="email" class="form-control" id="userEmail" v-model="family.userEmail" placeholder="E-mail">
                                    <div class="invalid-feedback">
                                        <span>{{ errors[0] }}</span>
                                    </div>
                                </validation-provider>
                            </div>
                        </div>
                        <!-- <div class="form-group row">
                            <label for="userPassword" class="col-sm-2 col-form-label">Wachtwoord *</label>
                            <div class="col-sm-10">
                                <validation-provider rule="required" v-slot="{ errors }">
                                    <input required autocomplete="new-password" type="password" class="form-control" id="userPassword" v-model="family.userPassword" placeholder="Wachtwoord">
                                    <div class="invalid-feedback">
                                        <span>{{ errors[0] }}</span>
                                    </div>
                                </validation-provider>
                            </div>
                        </div> -->
                        <h2>Stap 2: Voor welk familielid start u de Family Portal?</h2>
                        <div class="form-group row">
                            <label for="residentName" class="col-sm-2 col-form-label">Naam *</label>
                            <div class="col-sm-5">
                                <validation-provider rule="required" v-slot="{ errors }">
                                    <input required type="text" class="form-control" id="residentFirstName" v-model="family.residentFirstName" placeholder="Voornaam">
                                    <div class="invalid-feedback">
                                        <span>{{ errors[0] }}</span>
                                    </div>
                                </validation-provider>
                            </div>
                            <div class="col-sm-5">
                                <validation-provider rule="required" v-slot="{ errors }">
                                    <input required type="text" class="form-control" id="residentLastName" v-model="family.residentLastName" placeholder="Familienaam">
                                    <div class="invalid-feedback">
                                        <span>{{ errors[0] }}</span>
                                    </div>
                                </validation-provider>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="residentName" class="col-sm-2 col-form-label">Bijnaam</label>
                            <div class="col-sm-5">
                                <input type="text" class="form-control" id="residentNickName" v-model="family.residentNickname" placeholder="Bijnaam (bv. Opa Bril, Oma Poes)">
                            </div>
                            <label for="residentBirthday" class="col-sm-2 col-form-label">Geboortedatum</label>
                            <div class="col-sm-3">
                                <input type="date" class="form-control" id="residentBirthday" v-model="family.residentBirthday">
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="residentFacility" class="col-sm-2 col-form-label">Voorziening *</label>
                            <div class="col-sm-10">
                                <validation-provider rule="required" v-slot="{ errors }">
                                    <input required autocomplete="new-password" type="text" class="form-control" id="residentFacility" v-model="family.residentFacility" placeholder="De voorziening waar uw familielid verblijft">
                                    <div class="invalid-feedback">
                                        <span>{{ errors[0] }}</span>
                                    </div>
                                </validation-provider>
                            </div>
                        </div>
                        <div class="form-group row">
                            <div class="col-sm-8 offset-sm-2">
                                <button class="btn btn-danger" style="width: 40%; margin-top: 10px; margin-left: 10px;" @click.prevent="$emit('close-form')">Annuleren</button>
                                <button type="submit" class="btn btn-primary" style="width: 50%; margin-top: 10px; margin-left: 10px;" @click.prevent="submitForm()">Versturen</button>
                            </div>
                        </div>
                    </form>
                </validation-observer>
            </div>
        </div>
    </div>
</template>

<script>

// Vee Validate
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { required, email } from 'vee-validate/dist/rules'

// Add the required rule
extend('required', {
  ...required,
  message: 'Dit veld is verplicht'
})

// Add the email rule
extend('email', {
  ...email,
  message: 'Gelieve een correct e-mail adres op te geven'
})

// Axios
import axios from 'axios'

export default {
    components: {
        ValidationProvider, ValidationObserver
    },

    data() {
        return {
            family: {
                userName: '',
                userEmail: '',
                userPassword: '',
                residentLastName: '',
                residentFirstName: '',
                residentNickname: '',
                residentBirthday: '',
                residentFacility: '',
            },
        }
    },

    methods: {

        submitForm() {
            this.$refs.form.validate().then(success => {
                if(!success) {
                    return
                }
                axios.post(process.env.VUE_APP_SERVER_URL + '/api/create-family-from-website', this.family)
                    .then((res) => {
                        console.log(res)
                        // hide the form family and show the start with the app information
                        // bubble up email and password?
                        this.$emit('close-form', [ this.family.userEmail, this.family.userPassword])
                    })
                    .catch((err) => {
                        console.error(err)
                        console.log('should send me an email with the error')
                    })
                })
        }

    }
}
</script>

<style scoped>

.pricing-card {
    text-align: left !important;
}

.invalid-feedback {
    display: block !important;
}

</style>